import { render, staticRenderFns } from "./Configs.vue?vue&type=template&id=30a1ef9e&scoped=true"
import script from "./Configs.vue?vue&type=script&lang=js"
export * from "./Configs.vue?vue&type=script&lang=js"
import style0 from "./Configs.vue?vue&type=style&index=0&id=30a1ef9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a1ef9e",
  null
  
)

export default component.exports